import gql from 'graphql-tag'

const statsAgentiPieCharts = gql`
  query statsAgentiPieCharts(
    $mese: Int!, 
    $anno: Int!
  ) {
    statsAgentiPieCharts(
      mese: $mese, 
      anno: $anno
    ) {
      numeroTelefonateOut {
        nome
        colore
        valore
      }
      numeroEmailOut {
        nome
        colore
        valore
      }
      numeroWhatsappOut {
        nome
        colore
        valore
      }
      numeroClientiAssegnati {
        nome
        colore
        valore
      }
      numeroAppuntamentiSaltatiAnnullati {
        nome
        colore
        valore
      }
      numeroAppuntamentiStatoFissatoAgente {
        nome
        colore
        valore
      }
      numeroAppuntamentiStatoConfermatoSegretaria {
        nome
        colore
        valore
      }
      numeroAppuntamentiStatoFatto {
        nome
        colore
        valore
      }
      numeroAppuntamentiStatoConfermatoCliente {
        nome
        colore
        valore
      }
    }
  }
`

export default statsAgentiPieCharts


// WEBPACK FOOTER //
// ./src/graphql/queries/statsAgentiPieCharts.js